import { IDependencies } from '../../../interface/steps.interface';

interface Props {
  steps: string[][];
  values: Record<string, string | number>;
  dependencies: IDependencies
}

/**
 * Функция для определения номера текущего шага и проверки полноты заполнения шагов.
 * @param {Props} props - объект с полями steps и values.
 * @returns {Object} объект с номером текущего шага и флагом полноты заполнения шагов.
 */
const getCurrentStepNumber = ({ steps, values, dependencies }: Props) => {
  let isFullSteps = false;
  let currentStepNumber = 0;
  let isNext = true;

  steps.some((step: string[], index: number) => {
    const isStepFilled = step.every((name) => {
      if (dependencies[name]) {
        if (values[dependencies[name].name] === dependencies[name].value) {
          return values[name] && values[name] !== '';
        } else {
          return true
        }
      } else {
        return values[name] && values[name] !== '';
      }
    });

    if (isStepFilled && isNext) {
      currentStepNumber = index + 1;
    } else {
      isNext = false;
    }

    return !isNext;
  });

  if (currentStepNumber >= steps.length) {
    currentStepNumber = steps.length - 1;
    isFullSteps = true;
  }

  return {
    currentStepNumber,
    isFullSteps,
  };
};

export default getCurrentStepNumber;
